import React from 'react';
import RichTextComposer from '../RichTextComposer/RichTextComposerTiptap';
import styles from './FactionSectionsEditor.module.css';

const FactionSectionsEditor = ({ sections, onChange }) => {
  const updateSection = (index, patch) => {
    onChange(
      sections.map((section, sectionIndex) =>
        sectionIndex === index ? { ...section, ...patch } : section
      )
    );
  };

  const addSection = () => {
    onChange([...sections, { title: '', content: '' }]);
  };

  const removeSection = (index) => {
    if (index === 0) return;
    onChange(sections.filter((_, sectionIndex) => sectionIndex !== index));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>Sections de contenu</h2>
        <p className={styles.subtitle}>
          La première section est toujours « Description ». Ajoutez d&apos;autres sections selon vos besoins (Objectifs, Quartier général, etc.).
        </p>
      </div>

      {sections.map((section, index) => (
        <article key={section.id ?? `section-${index}`} className={styles.sectionCard}>
          <div className={styles.sectionCardHeader}>
            <label className={styles.field}>
              <span>Titre de la section</span>
              <input
                type="text"
                value={section.title}
                onChange={(event) => updateSection(index, { title: event.target.value })}
                className={styles.input}
                readOnly={index === 0}
                required={index === 0}
                placeholder={index === 0 ? 'Description' : 'Ex : Objectifs'}
              />
            </label>
            {index > 0 && (
              <button
                type="button"
                className={styles.removeBtn}
                onClick={() => removeSection(index)}
                aria-label={`Supprimer la section ${section.title || index + 1}`}
              >
                Supprimer
              </button>
            )}
          </div>

          <div className={styles.richTextField}>
            <RichTextComposer
              value={section.content}
              onChange={(value) => updateSection(index, { content: value })}
            />
          </div>
        </article>
      ))}

      <button type="button" className={styles.addBtn} onClick={addSection}>
        Ajouter une section
      </button>
    </div>
  );
};

export default FactionSectionsEditor;
